import get from 'lodash.get'
import jsCookies from 'js-cookie'
import protobuf from 'protobufjs'
import { Toast } from 'vant' // MessageBox
import protoRoot from '../proto/biz-proto/index'
// import protoRootStock from '../proto/biz-proto/stock-index'
import protoRootOpen from '../proto/biz-proto/open-index'
import protoRootSplit from '../proto/biz-proto/split-index'
import protoRootCommon from '../proto/biz-proto/common-index'
import protoRootUser from '../proto/biz-proto/user-index'
import protoEx from '../proto/biz-proto/ex'
import protoVipCustoms from '../proto/biz-proto--vip-customs'
import protoAli from '../proto/biz-proto/ali'


// import { PROTO_MODULE } from '../common/constant'
// import { getLocationQuery } from '../../common/utils'
import router from '../router'
import { getUUIDHeader, getSignatureHeader } from '../common/js/signature'

// const protoRoot = () => import(/* webpackChunkName: 'biz-proto-root' */ '../proto/biz-proto')
// const protoRootProduct = () => import(/* webpackChunkName: 'biz-proto-product' */ '../proto/biz-proto/product')
// const protoRootAIService = () => import(/* webpackChunkName: 'biz-proto-ai-service' */ '../proto/biz-proto/ai-service')
// const protoRootOrder = () => import(/* webpackChunkName: 'biz-proto-order' */ '../proto/biz-proto/order')
// const protoRootUser = () => import(/* webpackChunkName: 'biz-proto-user' */ '../proto/biz-proto/user')
// const protoRootWall = () => import(/* webpackChunkName: 'biz-proto-wall' */ '../proto/biz-proto/wall')
// const protoRootLottery = () => import(/* webpackChunkName: 'biz-proto-lottery' */ '../proto/biz-proto/lottery')
// const protoRootSearch = () => import(/* webpackChunkName: 'biz-proto-research' */ '../proto/biz-proto/search')

// const protoRootMapper = {
//   [PROTO_MODULE.PRODUCT]: protoRootProduct,
//   [PROTO_MODULE.ORDER]: protoRootOrder,
//   [PROTO_MODULE.AI_SERVICE]: protoRootAIService,
//   [PROTO_MODULE.USER]: protoRootUser,
//   [PROTO_MODULE.WALL]: protoRootWall,
//   [PROTO_MODULE.ROOT]: protoRoot,
//   [PROTO_MODULE.LOTTERY]: protoRootLottery,
//   [PROTO_MODULE.SEARCH]: protoRootSearch,
// }

function isArrayBuffer (obj) {
  return Object.prototype.toString.call(obj) === '[object ArrayBuffer]'
}
/**
 * 请求体序列化
 * @param {string} requestType 请求体buf类型
 */
function transformReqeustFactory (protoRoot, requestType) {
  /**
   * 请求参数序列化
   */
  return function transformResponse (rawData) {
    // 非空校验
    if (!rawData) {
      return rawData
    }
    try {
      const PBMessageData = protoRoot.lookup(requestType)
      var message = PBMessageData.create(rawData)
      var decodedDataBuffer = PBMessageData.encode(message).finish()
      console.log(PBMessageData.decode(decodedDataBuffer))
      return decodedDataBuffer
    } catch (err) {
      return err
    }
  }
}
/**
 * response反序列化
 * @param {string} responseType 返回值buf类型
 */
function transformResponseFactory (protoRoot, responseType) {
  return function transformResponse (rawResponse) {
    // 判断response是否是arrayBuffer
    if (rawResponse == null || !isArrayBuffer(rawResponse)) {
      return rawResponse
    }
    try {
      const buf = protobuf.util.newBuffer(rawResponse)
      // decode响应体
      const PBMessageResponse = protoRoot.lookup(responseType)
      const decodedResponse = PBMessageResponse.decode(buf)
      console.log(decodedResponse);
      return decodedResponse
    } catch (err) {
      return err
    }
  }
}
// function nativeXHR (postBuffer) {
//   var xhr = new XMLHttpRequest()
//   xhr.open('post', '/api/account/userInfo', true)
//   xhr.responseType = 'arraybuffer' // 坑点！
//   xhr.setRequestHeader('Content-Type', 'application/x-protobuf') //坑点！
//   xhr.setRequestHeader('Authorization', 'elIuFgmrgycjaZbD')
//   xhr.onload = function (response) {
//     console.log('response', response)
//     // var resObj = transformResponseFactory('proto.TSUserInfoSetResponse')(xhr.response)
//     const resMessage = protoRoot.lookup('proto.TSUserInfoSetResponse')
//     var msg = resMessage.decode(new Uint8Array(xhr.response)) // new Uint8Array() 坑点！
//     console.log('msg', msg)
//     var resObj = resMessage.toObject(msg)
//     console.log('resObj', resObj)
//   }
//   xhr.send(postBuffer)
// }

/**
 * @param {*} msgType 接口名称
 * @param {*} requestBody 请求体参数
 * @param {*} responseType 返回值
 */
async function request (options = {}, config = {}) {
  const lookupTypePathResponse = get(config, 'PB_LOOK_TYPE_PATH_RESPONSE')
  const lookupTypePathRequest = get(config, 'PB_LOOK_TYPE_PATH_REQUEST')
  const tokenRequired = get(config, 'TOKEN_REQUIRED') // 暂不处理登陆事宜
  const appraiserTokenRequired = get(config, 'APPRAISERTOKEN_REQUIRED') // 字节外包登录TOKEN
  const reviewTokenRequired = get(config, 'REVIEWTOKEN_REQUIRED') 
  const errAction = get(config, 'ERROR_ACTION') // 异常处理
  const httpAddress = get(config, 'httpAddress')
  const businessId = get(config, 'businessId')
  // const protoModule = protoRoot // get(config, 'PROTO_MODULE') // 异常处理
  // const { default: protoRoot } = await protoRootMapper[protoModule]()
  const toast = (message) => errAction === 'toast' && Toast(message)
  let useProtoRoot = protoRoot
  if(httpAddress === 'stock') {
    // useProtoRoot = protoRootStock
  } else if (httpAddress === 'open') {
    useProtoRoot = protoRootOpen
  } else if (httpAddress === 'split') {
    useProtoRoot = protoRootSplit
  } else if (httpAddress === 'common') {
    useProtoRoot = protoRootCommon
  } else if (httpAddress === 'user') {
    useProtoRoot = protoRootUser
  } else if (httpAddress === 'ex') {
    useProtoRoot = protoEx
  } else if (httpAddress === 'customs') {
    useProtoRoot = protoVipCustoms
  } else if (httpAddress === 'ali') {
    useProtoRoot = protoAli
  }
  const requestBody = transformReqeustFactory(useProtoRoot, lookupTypePathRequest)(options.data || {})
  // console.log('.., proto requestBody', requestBody)
  const { url, method = 'GET', headers = {} } = options
  const localHeaders = {
    'Content-Type': 'application/x-protobuf',
    // 'Authorization': 'elIuFgmrgycjaZbD'
  }
  if (tokenRequired) {
    const token = jsCookies.get('token')
  //   console.log(token)
  //   if (!token) {
  //     // toast('尚未登录，请重新登录')
  //     toast({
  //       message: '尚未登录，请重新登录',
  //       duration: 2000
  //     })
  //     let refer = options.refer || encodeURIComponent(location.href.split('#')[1])
  //     return router.push({ path: `/login?refer=${refer}` }) // 到登录页重新获取token
  //   }
    localHeaders.Authorization = decodeURIComponent(token)
  }
  if(appraiserTokenRequired){
    const appraiserToken=jsCookies.get('appraiserToken');
    localHeaders.Authorization = decodeURIComponent(appraiserToken)
  }
  if (reviewTokenRequired) {
    const reviewToken=jsCookies.get('reviewToken');
    localHeaders.Authorization = decodeURIComponent(reviewToken)
  }
  // 加密 reqeust
  const uuidHeader = getUUIDHeader()
  localHeaders['X-authorize-uuid'] = uuidHeader
  localHeaders['Signature'] = getSignatureHeader(uuidHeader)
  // console.log('header', headers)
  // console.log('localHeaders', localHeaders)
  
  return new Promise((resolve, reject) => {
    fetch(
      url,
      {
        method,
        headers: {
          ...localHeaders,
          ...headers
        },
        body: requestBody
      }).then(res => {
      const { status: httpStatus } = res
      if (httpStatus === 200) {
        // !!! arrayBuffer 转换 很关键
        return res.arrayBuffer()
      } else if (httpStatus === 401) {
        let refer = options.refer || encodeURIComponent(location.href)
        if (reviewTokenRequired) {
          router.replace({ path: `/review-series/review-login` }) // 到登录页重新获取token
        } else {
          router.replace({ path: `/login?refer=${refer}${businessId ? ('&businessId='+businessId) : ''}` }) // 到登录页重新获取token
        }
        toast('请先登录');
        return undefined
        // return undefined
      } else { // 其他类型 http 异常
        toast('服务异常，请稍后重试~~')
        console.log('res', res)
        console.log('httpStatus', httpStatus)
        return undefined
      }
    })
      .catch((err) => {
        console.warn(err)
        toast('网络异常~~')
        reject(new Error('网络异常~~'))
        throw new Error('网络异常~~')
      })
      .then(response => {
        if (!response) { // 其他类型 http 异常
          reject(new Error('服务异常，请稍后重试~~~'))
          return
        }
        try {
          let useProtoRoot = protoRoot
          if(httpAddress === 'stock') {
            // useProtoRoot = protoRootStock
          } else if (httpAddress === 'open') {
            useProtoRoot = protoRootOpen
          } else if (httpAddress == 'split') {
            useProtoRoot = protoRootSplit
          } else if (httpAddress == 'common') {
            useProtoRoot = protoRootCommon
          } else if (httpAddress == 'user') {
            useProtoRoot = protoRootUser
          } else if (httpAddress == 'ex') {
            useProtoRoot = protoEx
          } else if(httpAddress == 'customs') {
            useProtoRoot = protoVipCustoms
          } else if (httpAddress === 'ali') {
            useProtoRoot = protoAli
          }
          const resObj = transformResponseFactory(useProtoRoot, lookupTypePathResponse)(response)
          const { errorMsg, errorCode, errCode, errMsg } = resObj
          console.log('...... 反序列化', resObj)
          if (errorCode === 0 || errCode === 0 || errCode === 10065) {
            resolve(resObj)
          } else {
            toast(errorMsg || errMsg || '接口异常，请稍后重试~~')
            resolve(resObj)
          }
        } catch (e) {
          console.log('e', e)
          toast('序列化出错，请联系开发者~~')
          console.log('@@ 反序列化失败')
        }
      }, (err) => {
        console.warn(err)
        toast('网络异常~~')
        throw new Error(err || '网络异常~~')
      })
  })
}

export default request
